<template>
  <main id="driver-check" class="console-page-child control-page-common">
    <el-row class="console-title title-border">司机查询</el-row>
    <section class="search-model">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <el-row>
          <el-col :span="8" style="margin-top:6px">
            <el-autocomplete
              v-model="searchForm.nameMobile"
              :fetch-suggestions="querySearchAsync"
              clearable
              placeholder="请输入内容"
              :value-key="'val'"
              class="input-with-select"
            >
              <el-select
                @change="changeValue"
                v-model="searchForm.driverInfo"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option label="司机姓名" value="driverName"></el-option>
                <el-option label="注册手机号" value="mobile"></el-option>
              </el-select>
            </el-autocomplete>
          </el-col>
          <el-col :span="8">
            <el-form-item label="司机状态">
              <el-select v-model="searchForm.status" placeholder="请选择">
                <el-option
                  v-for="(item,
                  index) in contractConstant.contractStatusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.val"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" style="margin-left:20px">
              <el-select v-model="searchForm.sex" placeholder="请选择">
                <el-option
                  v-for="(item, index) in constant.sexOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.val"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="attach-company" label="挂靠公司">
              <el-search-input
                :params="{ searchType: 'DRIVERCOMPANY' }"
                :ruleForm="searchForm"
                :keyName="'attachCompany'"
                :url="'vehicle/GET_DRIVEROPERATOR_LIST'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="self-range-date" label="导入日期">
              <el-date-picker
                v-model="searchForm.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="btn-wrapper">
        <el-button type="primary" size="small" @click="filterBefore"
          >筛 选</el-button
        >
        <el-button size="small" @click="reset" class="reset">重 置</el-button>
      </el-row>
    </section>
    <el-export-btn
      :params="exportParams"
      keyUrl="/proxy/vehicle/driver/driver/export"
      statusUrl="/proxy/api/getFileUrl"
    />
    <el-table
      :data="driverList.data"
      style="width: 100%"
      :max-height="maxHeight"
    >
      <!-- <el-table-column>
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-row class="self-row">
              <el-col class="self-col" :span="item.span || 12" v-for="(item,index) in detailList(props.row)" :key="index">
                 <el-form-item :label="item.label">
                  <span>{{ item.formatter(props.row)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column> -->
      <el-table-column
        label="司机姓名"
        width="110px"
        :show-overflow-tooltip="true"
        prop="driverName"
        fixed
      >
      </el-table-column>
      <el-table-column
        label="注册手机号"
        width="130px"
        prop="mobile"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="司机状态"
        width="170px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-circle"
            :class="{
              'status-end': scope.row.status === 'TERMINATED',
              'status-ing': scope.row.status === 'ACTIVE',
              'status-unstart': scope.row.status === 'INACTIVE',
              'status-nocontract': scope.row.status === 'NONE',
            }"
          ></i>
          <span style="margin-left: 10px">{{
            contractConstant.contractStatusName[scope.row.status]
          }}</span>
          <el-popover
            v-if="
              scope.row.status === 'INACTIVE' || scope.row.status === 'ACTIVE'
            "
            placement="right-start"
            popper-class="self_popver_bg"
            trigger="hover"
          >
            <div class="self-contract-wrapper">
              <el-contract-card
                v-for="(item, index) in getContract(scope.row.contracts)"
                :key="index"
                :detail="item"
                :flag="true"
              />
            </div>
            <img
              slot="reference"
              src="../../assets/images/auth/alert-icon.svg"
              alt=""
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column width="100" label="性别" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.sex ? constant.sexName[scope.row.sex] : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        label="导入日期"
        width="180px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ moment(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        label="身份证号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.idNo ? scope.row.idNo : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="130"
        :show-overflow-tooltip="true"
        label="联系方式"
      >
        <template slot-scope="scope">
          {{ scope.row.contact ? scope.row.contact : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        label="驾驶证类别"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{
            scope.row.drivingLicenceType ? scope.row.drivingLicenceType : '--'
          }}
        </template>
      </el-table-column>

      <el-table-column
        width="210"
        label="驾驶证有效期"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ drivingLicenceValidity(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        :show-overflow-tooltip="true"
        label="居住地址"
      >
        <template slot-scope="scope">
          {{ scope.row.address ? scope.row.address : '--' }}
        </template>
      </el-table-column>
      <el-table-column width="120" label="经办人" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.operator ? scope.row.operator : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        label="紧急联系人"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{
            scope.row.emergencyContactName
              ? scope.row.emergencyContactName
              : '--'
          }}
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        label="紧急联系人联系方式"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{
            scope.row.emergencyContactMobile
              ? scope.row.emergencyContactMobile
              : '--'
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="挂靠公司"
        width="150px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.attachCompany ? scope.row.attachCompany : '--'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="180" fixed="right" label="操作">
        <template slot-scope="scope">
          <span
            v-for="(btn, index) in btns"
            :key="index"
            :class="btn.className"
            :style="{
              'border-right': btn.border(scope.row) ? '1px solid #DCDFE6' : '',
            }"
            @click="btn.callback(scope.row)"
            v-if="btn.formatter(scope.row)"
            >{{ btn.name }}</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="driverList.data && driverList.data.length > 0"
      layout="total, jumper, next, pager, prev"
      :current-page="driverList.pageNo"
      :page-size="driverList.pageSize"
      :total="driverList.totalItemCount"
      @current-change="currentChange"
    >
    </el-pagination>
    <el-check-driver-info v-if="showDriverCheckDialog" />
    <el-edit-driver-info v-if="showDriverEditDialog" />
    <el-contract-view></el-contract-view>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import checkDriverInfo from '../../components/driver-manage/check-driver-info'
import editDriverInfo from '../../components/driver-manage/edit-driver-info'
import * as constant from '../../constant/driver-type.ts'
import searchInput from '../../components/console-common/search-input.vue'
import * as contractConstant from '../../constant/common-type.ts'
import eventBus from '../../utils/fresh-table'
import contractCard from '../../components/console-common/contract-board.vue'
import contractView from '../../components/contract/contract-view.vue'
import exportBtn from '../../components/console-common/export-btn.vue'
export default {
  created() {
    this.getTableData()
    this.searchForm = Object.assign({}, { driverInfo: 'driverName' })
  },
  mounted() {
    eventBus.$on('freshTable', this.filter)
  },
  components: {
    'el-check-driver-info': checkDriverInfo,
    'el-edit-driver-info': editDriverInfo,
    'el-search-input': searchInput,
    'el-contract-card': contractCard,
    'el-contract-view': contractView,
    'el-export-btn': exportBtn,
  },
  data() {
    return {
      exportParams: {},
      requestConfig: {
        storeName: 'driver/GET_DRIVER_LIST',
        params: {
          pageSize: 20,
          pageNo: 1,
        },
      },
      btns: [
        {
          name: '查看',
          className: 'normal-btn',
          callback: (val) => {
            this.handleEdit(val, 'check')
          },
          formatter: () => {
            return true
          },
          border: () => {
            return true
          },
        },
        {
          name: '编辑',
          className: 'normal-btn',
          callback: (val) => {
            this.handleEdit(val, 'edit')
          },
          formatter: () => {
            // return val.status==='NONE' || val.status==='TERMINATED'
            return true
          },
          border: (val) => {
            return val.status === 'NONE' || val.status === 'TERMINATED'
          },
        },
        {
          name: '删除',
          className: 'delete-btn',
          callback: (val) => {
            this.handleDelete(val.driverCode)
          },
          formatter: (val) => {
            return val.status === 'NONE' || val.status === 'TERMINATED'
          },
          border: () => {
            return false
          },
        },
      ],
      expands: [],
      pageNo: 1,
      pageSize: 20,
      constant: constant,
      contractConstant: contractConstant,
      searchForm: {},
    }
  },
  computed: {
    ...mapState('vehicle', ['searchList']),
    ...mapState('driver', [
      'showDriverCheckDialog',
      'showDriverEditDialog',
      'driverList',
    ]),
    maxHeight() {
      return window.innerHeight - 164
    },
  },
  methods: {
    detailList() {
      // 展开的表格里数据
      return [
        {
          label: '身份证号：',
          span: 7,
          formatter(row) {
            return row.idNo ? row.idNo : '--'
          },
        },
        {
          label: '经办人：',
          formatter(row) {
            return row.operator ? row.operator : '--'
          },
        },
        {
          label: '联系方式：',
          span: 7,
          formatter(row) {
            return row.contact ? row.contact : '--'
          },
        },
        {
          label: '紧急联系人：',
          span: 14,
          formatter(row) {
            return row.emergencyContactName ? row.emergencyContactName : '--'
          },
        },
        {
          label: '驾驶证类别：',
          span: 7,
          formatter(row) {
            return row.drivingLicenceType ? row.drivingLicenceType : '--'
          },
        },
        {
          label: '紧急联系人联系方式：',
          span: 14,
          formatter(row) {
            return row.emergencyContactMobile
              ? row.emergencyContactMobile
              : '--'
          },
        },
        {
          label: '驾驶证有效期：',
          span: 7,
          formatter(row) {
            return row.drivingLicenceValidityStart
              ? `${moment(row.drivingLicenceValidityStart).format(
                  'YYYY-MM-DD'
                )}至${moment(row.drivingLicenceValidityEnd).format(
                  'YYYY-MM-DD'
                )}`
              : '--'
          },
        },
        {
          label: '居住地址：',
          span: 24,
          formatter(row) {
            return row.address ? row.address : '--'
          },
        },
      ]
    },
    getContract(list) {
      let array = []
      if (list && list.length) {
        list.forEach((ele) => {
          let obj = {
            orderNo: '',
            status: '',
            list: [],
          }
          obj.orderNo = ele.contractCode
          obj.status = ele.contractProcess
          obj.list = [
            {
              key: '司机姓名',
              val: ele.driverName,
            },
            {
              key: '车牌号',
              val: ele.plateNumber,
              push: 4,
            },
            {
              key: '业务模式',
              val: contractConstant.leaseMode[ele.leaseMode],
              span: 24,
            },
            {
              key: '合同有效期',
              val: `${moment(ele.startTime).format('YYYY-MM-DD')} 至 ${moment(
                ele.endTime
              ).format('YYYY-MM-DD')}`,
              span: 24,
            },
          ]
          array.push(obj)
        })
      }
      return array
    },
    reset() {
      // 重置
      this.searchForm = Object.assign({}, { driverInfo: 'driverName' })
      this.pageNo = 1
      this.filter()
    },
    filterBefore() {
      this.pageNo = 1
      this.filter()
    },
    // getRowKeys(row) {
    //   return row.driverCode
    // },
    currentChange(val) {
      this.pageNo = val
      this.filter()
    },
    changeValue(value) {
      this.searchForm = Object.assign({}, { nameMobile: '' })
      this.searchForm.driverInfo = value
    },
    querySearchAsync(queryString, cb) {
      const type =
        this.searchForm.driverInfo === 'driverName'
          ? 'DRIVERNAME'
          : 'DRIVERMOBILE'
      this.$store.dispatch('vehicle/GET_DRIVEROPERATOR_LIST', {
        searchType: type,
        key: queryString,
      })
      setTimeout(() => {
        cb(this.searchList)
      }, 1000)
    },
    filter() {
      const name = this.searchForm.driverInfo
      this.searchForm[name] = this.searchForm.nameMobile
      if (this.searchForm.createTime) {
        this.searchForm.createTimeStart = this.searchForm.createTime[0]
        this.searchForm.createTimeEnd = this.searchForm.createTime[1]
      }
      const params = {
        driverName: this.searchForm.driverName,
        sex: this.searchForm.sex,
        mobile: this.searchForm.mobile,
        attachCompany: this.searchForm.attachCompany,
        status: this.searchForm.status,
        createTimeStart: this.searchForm.createTimeStart,
        createTimeEnd: this.searchForm.createTimeEnd,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.exportParams = params
      this.$store.dispatch('driver/GET_DRIVER_LIST', {
        ...params,
      })
    },
    getTableData() {
      // 获取表格信息
      this.$store.dispatch('driver/GET_DRIVER_LIST', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
    },
    handleEdit(row, type) {
      this.$store.dispatch('driver/GET_DRIVER_DETAIL_INFO', {
        driverCode: row.driverCode,
        type,
      })
    },
    handleDelete(driverCode) {
      this.$confirm('', '', {
        message: '<p class="title">您确认要删除该司机吗？</p>',
        dangerouslyUseHTMLString: true,
        showClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'self-confirm delete-confirm',
      })
        .then(() => {
          this.$request({
            url: '/proxy/vehicle/driver/driver/delete',
            method: 'post',
            data: {
              driverCode,
            },
          }).then((res) => {
            if (!res.errorCode) {
              this.$message({
                type: 'success',
                message: '删除成功',
              })
              eventBus.$emit('freshTable')
            } else {
              this.$message.error(res.errorMsg)
            }
          })
        })
        .catch(() => {})
    },
    // expandSelect(row,expandedRows) { // 只能展开一行
    //   const keys = this.expands[0]
    //   if(keys === row.driverCode) {
    //     this.expands =  []
    //   } else {
    //     this.expands = []
    //     this.expands.push(row.driverCode)
    //   }
    // },
    moment(date) {
      // 格式化日期
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return '--'
      }
    },
    drivingLicenceValidity(item) {
      const {
        drivingLicenceValidityType,
        drivingLicenceValidityStart,
        drivingLicenceValidityEnd,
      } = item
      return drivingLicenceValidityType
        ? '长期'
        : drivingLicenceValidityStart
        ? `${this.moment(drivingLicenceValidityStart)}至${this.moment(
            drivingLicenceValidityEnd
          )}`
        : '--'
    },
  },
  watch: {
    driverList: function(val) {
      if (val.data && val.data.length) {
        this.expands.push(val.data[0].driverCode)
      }
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/common-color.styl'
#driver-check
 .self-col
    height 22px
    margin-bottom 16px
  .el-pagination
    position inherit
    width 100%
  .search-model
    margin 24px 0 60px 0
    .el-input__inner
      width 225px
      height 32px
    .el-range-editor
      padding 0
      padding-left 4px
    .input-with-select
      .el-input-group__prepend
        background white
      .el-input__inner
        width 200px
      .el-select
        .el-input__inner
          width 120px
    .btn-wrapper
      margin-left 99px
      .el-button
        width 64px
        height 32px
        text-align center
        box-sizing border-box
        span
          font-family PingFangSC-Medium
      .el-button--primary,.el-button--default
        padding 0
    .attach-company
      margin-left 19px
  .normal-btn
    padding 0 8px
    color primary-color
    cursor pointer
  .delete-btn
    padding 0 8px
    color error-color
    cursor pointer
  .el-icon-circle
    width 6px
    height 6px
    border-radius 50%
  .status-ing
    background self-green
  .status-end
    background gray03
  .status-unstart
    background  primary-color
  .status-nocontract
    background gray05
.self_popver_bg
  background  #ebeef5
  padding 0
.self-contract-wrapper
  max-height 315px
  overflow-y auto
  overflow-x hidden
  .contract-board
    background white
    border none
    margin-bottom 8px
  .self-contract-board
    width 340px
    background white
.self-contract-wrapper::-webkit-scrollbar
  width 8px
  height 8px
.self-contract-wrapper::-webkit-scrollbar-thumb
  border-radius 5px
  -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.2)
  background #ebedf1
.self-contract-wrapper::-webkit-scrollbar-track
  display none
</style>
